module.exports = __webpack_public_path__ + "static/media/card_suits_spade.3aae09f1.png";